module.exports = __webpack_public_path__ + "static/media/drivers_license.269de346.svg";